<template>
  <div class="edit-video-box">
    <el-dialog
      :title="title1"
      :visible.sync="dialogVisible"
      width="350px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="params"
        :rules="rules"
        label-width="90px"
        :label-position="labelPosition"
      >
        <el-form-item label="回执信息:" prop="receiptInfo">
          <el-input
            v-model="params.receiptInfo"
            size="small"
            type="textarea"
            :rows="4"
            placeholder="回执信息"
          ></el-input>
        </el-form-item>
        <el-form-item label="开始时间:" prop="startTime" v-if="this.type=='pass'">
          <el-date-picker
            v-model="params.startTime"
            type="datetime"
            :editable="false"
            placeholder="请输入开始时间"
            size="small"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:" prop="endTime" v-if="this.type=='pass'">
          <el-date-picker
            v-model="params.endTime"
            type="datetime"
            :editable="false"
            placeholder="请输入结束时间"
            size="small"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align:center">
        <el-button @click="handleClose" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" :loading="flag" size="small">确 认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "@/api";
import { changeTime } from "@/utils/global";
export default {
  data() {
    return {
      labelPosition: "left",
      dialogVisible: false,
      title1: "",
      type: "",
      flag: false,
      id: "",
      // 审核通过/拒绝 表单数据
      params: {
        pass: "",
        receiptInfo: "",
        startTime: "",
        endTime: "",
      },

      // 表单验证规则
      rules: {
        receiptInfo: [
          { required: true, message: "请填写回执信息", trigger: "blur" },
        ],
        startTime: [
          { required: true, message: "请输入开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请输入结束时间", trigger: "blur" },
        ],
      },
    };
  },

  methods: {
    // 表单验证提交
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.flag = true;
          if (this.type === "pass") {
            this.passReview();
          } else {
            this.refuseReview();
          }
        } else {
          return false;
        }
      });
    },
    // 通过
    passReview() {
      let params = Object.assign({}, this.params, {
        id: this.id,
        pass: true,
        startTime: changeTime(this.params.startTime),
        endTime: changeTime(this.params.endTime),
      });
      API.AdReview(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("handlerAgentList");
          } else {
            if (res.tip) {
              this.$message.error(res.tip);
            } else {
              this.$message.error("操作失败");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },
    // 拒绝
    refuseReview() {
      let params = Object.assign(
        {},
        { id: this.id, pass: false, receiptInfo: this.params.receiptInfo }
      );
      API.AdReview(params)
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.$emit("handlerAgentList");
          } else {
            if (res.tip) {
              this.$message.error(res.tip);
            } else {
              this.$message.error("操作失败");
            }
          }
          this.handleClose();
          this.flag = false;
        })
        .catch(() => {
          this.handleClose();
          this.flag = false;
        });
    },

    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.$refs.form.resetFields();
      this.params = {
        pass: "",
        receiptInfo: "",
        startTime: "",
        endTime: "",
      };
    },
    // 打开编辑视频弹窗、传递需要编辑的参数
    open(type, data) {
      this.dialogVisible = true;
      this.type = type;
      this.id = data.id;
      if (type === "pass") {
        this.title1 = "通过审核信息编辑";
        this.params.pass = data.pass;
        this.params.receiptInfo = data.receiptInfo;
        this.params.startTime = data.startTime;
        this.params.endTime = data.endTime;
      } else {
        this.title1 = "拒绝审核信息编辑";
      }
    },
  },
};
</script>

<style lang="scss">
.edit-video-box {
  .item-box {
    margin-left: 28px;
    width: 100%;
    display: flex;
    .item1 {
      flex: 1;
      .upload {
        position: relative;
        top: 35px;
        left: -90px;
      }
    }
    .item2 {
      flex: 3;
      width: 250px;
      position: relative;
      top: 0px;
      left: -60px;
    }
  }
}
</style>
